import React from 'react';
import ContactPage from '../../components/ContactPage/ContactPage';
import { graphql } from 'gatsby';

export default (props) => <ContactPage {...props} />;

export const query = graphql`
  {
    page: sanityContactPg(_id: { eq: "contactPg" }) {
      meta: _rawMeta
      title
      body: _rawBody
      formTitle
      formId
    }
  }
`;
